module.exports = __webpack_public_path__ + "static/media/calm.745803ad.webp";